import rpcCall from '../../util/rpc/rpcCalls'
import {LOAD_COMMENTS_LIMIT, NUMBER_ALLOWED_CHARACTERS} from './constants'
import {setEntityCommentsInLocalStorage} from './utils'
import {createActionObject} from '../../redux/utils'

export default function({
    actions: {
        saveCommentSuccess,
        loadMoreCommentsSuccess,
        deleteCommentSuccess,
        clearCommentsInfo,
        changeCommentsOrder,
        setCommentsLoading,
        setSendingComment,
        setCommentsLoaded,
        resetCommentsScrollTo,
        setEditingCommentId,
        updateEditingCommentText,
        cancelEditComment,
        updateCommentSuccess,
        setUpdatingCommentId,
        removeComment,
        setShowNewCommentInput,
        removeNewComment,
        updateCommentsCountSuccess = (entityId, commentsInfo) => (dispatch) => {},
    },
    selectors: {
        getOpenEntityId,
        getComments,
        getEditingCommentId,
        getEditingCommentText,
        getUpdatingCommentId,
        getNewestCommentId,
        isNewCommentsOnTop,
        needMoreComments,
        getNewCommentsTexts,
    } = {},
    handleServiceError,
    entityType,
}) {

    const reloadComments = () => dispatch => {
        dispatch(clearCommentsInfo())
        dispatch(loadMoreComments())
    }

    const loadMoreComments = () => (dispatch, getState) => {
        const state = getState()
        const entityId = getOpenEntityId(state)
        if (entityId !== null && needMoreComments(state)) {
            dispatch(setCommentsLoading(true))
            const offset = getComments(state).length
            rpcCall('EntityCommentsService.getCommentsInfo', [entityId, entityType, offset, LOAD_COMMENTS_LIMIT],
                (error) => handleServiceError(entityId, error, dispatch))
                .then(commentsInfo => {
                    dispatch(loadMoreCommentsSuccess(commentsInfo, offset, isNewCommentsOnTop(getState())))
                })
                .catch((error) => {
                    dispatch(setCommentsLoading(false))
                    console.error(error)
                })
        }
    }

    const saveComment = (text) => (dispatch, getState) => {
        const state = getState()
        const entityId = getOpenEntityId(state)
        const newestCommentId = getNewestCommentId(state)
        dispatch(setSendingComment(true))
        rpcCall('EntityCommentsService.saveComment', [entityId, entityType, text, newestCommentId],
            (error) => handleServiceError(entityId, error, dispatch))
            .then(commentsInfo => {
                dispatch(updateCommentsCountSuccess(entityId, commentsInfo))
                dispatch(removeNewComment(entityId))
                dispatch(saveCommentSuccess(commentsInfo))
                dispatch(saveEntityNewCommentsTextsInLocalStorage())
            })
            .catch((error) => {
                dispatch(setSendingComment(false))
            })
    }

    const deleteComment = (commentId) => (dispatch, getState) => {
        const state = getState()
        const entityId = getOpenEntityId(state)
        const newestCommentId = getNewestCommentId(state)
        rpcCall('EntityCommentsService.deleteComment', [entityId, entityType, commentId, newestCommentId],
            (error) => handleServiceError(entityId, error, dispatch))
            .then(commentsInfo => {
                dispatch(updateCommentsCountSuccess(entityId, commentsInfo))
                dispatch(deleteCommentSuccess(commentId, commentsInfo))
            })
            .catch((error) => {})
    }

    const saveEditingComment = () => (dispatch, getState) => {
        const state = getState()
        const editingCommentId = getEditingCommentId(state)
        if (editingCommentId !== null) {
            const prevText = getComments(state).find(c => c.id === editingCommentId).text
            const newText = getEditingCommentText(state)

            if (newText !== prevText && newText.length <= NUMBER_ALLOWED_CHARACTERS) {
                const entityId = getOpenEntityId(state)
                const newestCommentId = getNewestCommentId(state)
                dispatch(setUpdatingCommentId(editingCommentId))
                rpcCall('EntityCommentsService.editComment', [editingCommentId, entityId, entityType, newText, newestCommentId],
                    (error) => handleServiceError(entityId, error, dispatch))
                    .then(data => {
                        dispatch(updateCommentSuccess(data))
                    })
                    .catch((error) => {
                        dispatch(setUpdatingCommentId(null))
                        dispatch(setEditingCommentId(null))

                        if (error.getTextStatus() === 'rpc_customException'
                            && error.getErrorThrown().exception === 'com.actimind.actitime.services.impl.comments.NoSuchCommentException') {
                            dispatch(removeComment(editingCommentId))
                        }
                    })
            } else {
                dispatch(setEditingCommentId(null))
            }
        }
    }

    const startEditComment = (id) => (dispatch, getState) => {
        const state = getState()
        const updatingCommentId = getUpdatingCommentId(state)
        if (updatingCommentId !== null) return

        const editingCommentId = getEditingCommentId(state)
        if (editingCommentId !== null && id !== editingCommentId) {
            dispatch(saveEditingComment())
            //hack to show other comment edit input if server response quickly, otherwise show loading moire
            setTimeout(() => {
                if (getUpdatingCommentId(getState()) === null) {
                    dispatch(setEditingCommentId(id))
                }
            }, 100)
        } else {
            dispatch(setEditingCommentId(id))
        }
    }

    const toggleNewCommentInput = (isShown) => (dispatch, getState) => {
        const state = getState()
        const editingCommentId = getEditingCommentId(state)
        if (editingCommentId !== null) {
            dispatch(saveEditingComment())
        }

        dispatch(setShowNewCommentInput(isShown))
    }

    const saveEntityNewCommentsTextsInLocalStorage = () => (dispatch, getState) => {
        setEntityCommentsInLocalStorage(entityType, getNewCommentsTexts(getState()))
    }

    return {
        reloadComments,
        loadMoreComments,
        saveComment,
        deleteComment,
        saveEditingComment,
        startEditComment,
        toggleNewCommentInput,
        saveEntityNewCommentsTextsInLocalStorage,
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/comments/commentsActionsGenerator.js